import script from "./SimpleSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleSlider.vue?vue&type=script&setup=true&lang=js"

import "./SimpleSlider.vue?vue&type=style&index=0&id=08c3453e&lang=scss"

const __exports__ = script;

export default __exports__